(function () {
  const collapse = document.getElementById('accordion-collapse');
  if (collapse) {
    const accordionTitles = document.querySelectorAll(
      '.accordion-collapse-heading'
    );
    for (let i = 0; i < accordionTitles.length; i++) {
      accordionTitles[i].addEventListener('click', function () {
        this.classList.toggle('active');
        const content = this.nextElementSibling;
        for (let j = 0; j < accordionTitles.length; j++) {
          accordionTitles[j].classList.remove('my-collapse-item-active');
          if (j != i) {
            accordionTitles[j].nextElementSibling.classList.add('hidden');
          }
        }

        if (content.classList.contains('hidden')) {
          content.classList.remove('hidden');
          this.classList.add('my-collapse-item-active');
        } else {
          content.classList.add('hidden');
          this.classList.remove('my-collapse-item-active');
        }
      });
    }
  }


  const collapseFaq = document.getElementById('accordion-collapse-secondary');
  if (collapseFaq) {
    const accordionTitles = document.querySelectorAll(
      '.accordion-collapse-heading'
    );
    for (let i = 0; i < accordionTitles.length; i++) {
      accordionTitles[i].addEventListener('click', function () {
        this.classList.toggle('active');
        const content = this.nextElementSibling;
        for (let j = 0; j < accordionTitles.length; j++) {
          accordionTitles[j].classList.remove('my-collapse-item-secondary');
          if (j != i) {
            accordionTitles[j].nextElementSibling.classList.add('hidden');
          }
        }

        if (content.classList.contains('hidden')) {
          content.classList.remove('hidden');
          this.classList.add('my-collapse-item-secondary');
        } else {
          content.classList.add('hidden');
          this.classList.remove('my-collapse-item-secondary');
        }
      });
    }
  }


  const collapseEbook = document.getElementById('accordion-collapse-eBook');
  
  if (collapseEbook) {
  const accordionTitlesEbook = document.querySelectorAll(
    '.accordion-collapse-heading-ebook'
  );

  for (let i = 0; i < accordionTitlesEbook.length; i++) {
    accordionTitlesEbook[i].addEventListener('click', function () {
      this.classList.toggle('active');
      const content = this.nextElementSibling;
      for (let j = 0; j < accordionTitlesEbook.length; j++) {
        accordionTitlesEbook[j].classList.remove('my-collapse-item-active-ebook');
        if (j != i) {
          accordionTitlesEbook[j].nextElementSibling.classList.add('hidden');
        }
      }

      if (content.classList.contains('hidden')) {
        content.classList.remove('hidden');
        this.classList.add('my-collapse-item-active-ebook');
      } else {
        content.classList.add('hidden');
        this.classList.remove('my-collapse-item-active-ebook');
      }
    });
  }
}

})();
